import { useContext } from 'react'
import { CollapseDrawerContext } from 'contexts'

// ----------------------------------------------------------------------

const useCollapseDrawer = () => useContext(CollapseDrawerContext)

export default useCollapseDrawer
